import React, { useState } from 'react';

import { ProButton } from '@components/Button/variants';
import Separator from '@components/Comments/Separator';
import CheckCircle from '@components/Images/CheckCircle';

import { START_TRIAL_TEXT } from './ConfirmationModal';
import ConfirmationModal from './ConfirmationModal';
import Disclosure from './Disclousre';

const PERKS = [
  '70+ company Org Charts',
  'Deep Research AI tool',
  'Deep Research Reports',
  '6+ informative newsletters',
  'Subscriber survey results',
  'Frequently updated databases',
];

interface FirstSectionProps {
  offerCode: string;
  costChargedToday: number;
}

const FirstSection = ({ offerCode, costChargedToday }: FirstSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <div className="flex max-w-full flex-col sm:max-w-[320px] md:max-w-[542px]">
      <h1 className="my-0 font-suisse-works text-headline-sm md:text-headline-md lg:text-headline-lg">
        Renew today and receive 3 months of Pro on us!
      </h1>
      <p className="mb-0 font-suisse-neue  text-body-md text-grayscale-charcoal sm:text-body-lg">
        Stay with us for three more months at no cost and unlock exclusive access to our Deep
        Research tool, proprietary AI databases, and industry org charts to ensure you remain the
        most informed person in the room.
      </p>
      <ProButton as="button" className="mt-32" size="big" onClick={handleOpenModal}>
        {START_TRIAL_TEXT}
      </ProButton>
      <Separator className="my-32 !block h-[1px] w-full" />
      <h3 className="font-suisse-works text-headline-xs">Exclusive and Rare Access</h3>
      <div className="flex flex-col items-start gap-x-8 gap-y-16">
        {PERKS.map((perk) => (
          <div key={perk} className="flex items-center gap-x-8">
            <CheckCircle className="text-primary-magenta" />
            <p className="m-0 font-suisse-intl text-body-sm text-grayscale-charcoal md:text-body-md lg:text-body-lg">
              {perk}
            </p>
          </div>
        ))}
      </div>
      <Separator className="my-32 !block h-[1px] w-full" />
      <Disclosure className="hidden sm:block" />
      <ConfirmationModal
        closeModal={handleCloseModal}
        costChargedToday={costChargedToday}
        offerCode={offerCode}
        isOpen={isOpen}
      />
    </div>
  );
};

export default FirstSection;
